module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/07_shape-lg-237c27c0607c97e3fc87476dfb81368a.png";